module.exports = __webpack_public_path__ + "img/line.bdbb1a37.svg";